export default __webpack_public_path__ + "static/media/reg-3.9386942e.jpeg";